/*
 *   File : view-question.js
 *   Author : https://evoqins.com
 *   Description : View added question modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React from 'react';

// custom components
import { Icon } from '../Icon';

const ViewQuestionModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("view-question-modal-close");
        button.click();
        props.handleClose();
    };


    return (
        <div className="modal fade"
            id="view-question-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="viewQuestionModalLabel"
            aria-hidden="true">

            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28">
                <span id='view-question-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            View Question
                        </h6>

                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-2 padding-32px-lr padding-32px-bottom'>
                        <div className='e-bg-magnolia py-4 px-3 border-radius-8 e-border-1px-pale-lavender-extra-light'>
                            <div className='e-border-bottom-1px-platinum-light pb-3'>
                                <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                    Question
                                </p>
                                <p className='mb-0 e-text-dim-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                    {props.data.question}
                                </p>
                            </div>

                            <div className='d-flex align-items-start gap-32px flex-wrap  pt-3'>
                                <div>
                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                        Question type
                                    </p>
                                    <p className='mb-0 e-text-dim-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                        {props.data.question_type_text}
                                    </p>
                                </div>

                                {props.data.question_type === 2 &&
                                    <div>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Option type
                                        </p>
                                        <p className='mb-0 e-text-dim-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                            {props.data.config.range_type === 1 ? "Amount" : props.data.config.range_type === 2 ? "Years" : "Percentage"}
                                        </p>
                                    </div>
                                }
                            </div>
                        </div>

                        {/* Option & Score  */}
                        <div className='pt-4'>
                            <p className='mb-3 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                Option & Score
                            </p>

                            <div className='e-bg-magnolia py-4 px-3 border-radius-8 e-border-1px-pale-lavender-extra-light'>
                                <div className='row pb-2'>
                                    <div className='col-5'>
                                        <p className='mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Option
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Score
                                        </p>
                                    </div>
                                </div>

                                {props.data.question_type === 1 || props.data.question_type === 3 ?
                                    props.data.answers.map((answer, key) => (
                                        <div className='row pb-2' key={answer.id}>
                                            <div className='col-5'>
                                                <p className='mb-0 e-text-dim-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                                    {answer.label}
                                                </p>
                                            </div>
                                            <div className='col-4'>
                                                <p className='mb-0 e-text-dim-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                                    {answer.score}
                                                </p>
                                            </div>
                                        </div>
                                    ))
                                    : props.data.config?.slabs?.map((slab, key) => (
                                        <div className='row pb-2' key={slab.id}>
                                            <div className='col-5'>
                                                <p className='mb-0 e-text-dim-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                                    {props.data.config.range_type === 2 ?
                                                        `${slab.range_start} yr${slab.range_start > 1 ? 's' : ''} - ${slab.range_end} yr${slab.range_end > 1 ? 's' : ''}`
                                                        : props.data.config.range_type === 3 ?
                                                            `${slab.range_start}% - ${slab.range_end}%`
                                                            :
                                                            `₹${slab.range_start} - ₹${slab.range_end}`
                                                    }
                                                </p>
                                            </div>
                                            <div className='col-4'>
                                                <p className='mb-0 e-text-dim-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                                    {slab.score}
                                                </p>
                                            </div>
                                        </div>
                                    ))
                                }


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewQuestionModal;
